import api from "./request";

const goMe = () => {
  return api.get("/go/core/auth/doctor/me");
};

const getRoomStreamByRoomId = roomId => {
  return api.get(`/go/circle/doctor/roomstream/${roomId}`);
};

const getRoomConferenceByRoomId = roomId => {
  return api.get(`/go/circle/doctor/roomconference/${roomId}`);
};

const notifyStartStream = data => {
  return api.post("/go/circle/doctor/livestream/notify/start", data);
};

const notifyStopStream = data => {
  return api.post("/go/circle/doctor/livestream/notify/stop", data);
};

const checkMyRoleConferenceRoom = data => {
  return api.post("/go/circle/doctor/role/conference", data);
};

const getListConferenceSchedules = paramsData => {
  const params = new URLSearchParams(paramsData).toString();
  return api.get(`/go/conference/conference_session?${params}`);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  goMe,
  getRoomStreamByRoomId,
  getRoomConferenceByRoomId,
  notifyStartStream,
  notifyStopStream,
  checkMyRoleConferenceRoom,
  getListConferenceSchedules,
};
